/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { WarningAmber } from "@mui/icons-material";
import { ButtonBase } from "@mui/material";
import React, { useState } from "react";
import { OrganizationsHintsModal } from "./OrganizationHintsModal";
import { ProductUnion } from "../../types/ProductUnion";

type OrganizationHintsModalToggleProps = {
  product: ProductUnion;
};

export const OrganizationHintsModalToggle = ({ product }: OrganizationHintsModalToggleProps)=> {
  const [showOrganizationHintsModal, setShowOrganizationHintsModal] = useState(false);

  const { opposingPartyLegalEntity } = product;

  return (
    <>
      <ButtonBase
        sx={{
          color: opposingPartyLegalEntity?.organization.insolvencyStatus ? "error.main" : "warning.light",
          font: "inherit",
        }}
        onClick={() => setShowOrganizationHintsModal(true)}
      >
        ./. {product.opposingParty}{" "}
        <WarningAmber sx={{ fontSize: "1.25rem", marginLeft: "0.25rem", marginBottom: "0.25rem" }} />
      </ButtonBase>
      <OrganizationsHintsModal
        product={product}
        onClose={() => setShowOrganizationHintsModal(false)}
        show={showOrganizationHintsModal}
      />
    </>
  );
}
